import { types } from 'mobx-state-tree';
import { PolygonGeometry } from './polygon';
import { TAPlanGeometryAttributes } from './taGeometryAttributes';

const TAPolygon = types
  .model('TAPolygon', {
    polygon: types.maybe(PolygonGeometry)
  })
  .actions(self => ({
    update: graphic => {
      self.comment = graphic.attributes.comment;
      self.snapshotIndex = graphic.attributes.snapshotIndex;
      self.polygon = graphic.geometry.toJSON();
    }
  }));

export const TARegulationPolygon = types.compose(TAPlanGeometryAttributes, TAPolygon).named('TARegulationPolygon');
